<div
  class="component-container sm:min-w-[25rem] md:min-w-[60rem] md:max-w-[60rem] h-full flex flex-col justify-center">
  <div class="heading">
    Edit Data
  </div>
  <hr>
  <div class="content">
    <div class="row flex flex-row justify-between items-center">
      <div class="label w-1/2">
        Date
      </div>
      <app-date-picker
        class="date-picker-input w-1/2"
        [parentFormGroup]="form"
        controlName="recordedOn"
        [max]="maxDate"
        [error]="errorMessages['recordedOn']"
        (checkForErrors)="checkForErrors($event)"
        placeholder="Select a date"
        type="small"
      ></app-date-picker>
    </div>

    <div
      [ngSwitch]="metricOption.code"
      class="measurement-inputs"
    >
      <div *ngSwitchCase="constants.metricOption.weight">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
           {{metricOption?.name}}
          </div>
          <app-number-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="value"
            [error]="errorMessages['value']"
            placeholder="000.00"
            type="small"
          ></app-number-input>
        </div>
      </div>

      <div *ngSwitchCase="constants.metricOption.height">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{metricOption?.name}}
          </div>
          <app-height-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="value"
            [error]="errorMessages['value']"
            type="small"
          ></app-height-input>
        </div>
      </div>

      <div *ngSwitchCase="constants.metricOption.bp">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{metricOption?.name}}
          </div>
          <app-blood-pressure-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="value"
            [error]="errorMessages['value']"
            placeholder="sys/dia"
            type="small"
            (checkForErrors)="checkForErrors($event)"
          ></app-blood-pressure-input>
        </div>
      </div>

      <div *ngSwitchDefault>
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{metricOption.name}}
          </div>
          <ng-container
            *ngIf="metricOption.type===1;else numberInputComponent;">
            <app-text-input
              class="w-1/2"
              [parentFormGroup]="form"
              controlName="value"
              [error]="errorMessages['value']"
              placeholder="00"
              [minLength]="0"
              type="small"
            ></app-text-input>
          </ng-container>
          <ng-template #numberInputComponent>
            <app-number-input
              class="w-1/2"
              [parentFormGroup]="form"
              controlName="value"
              [error]="errorMessages['value']"
              placeholder="00"
              type="small"
            ></app-number-input>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="action-panel flex flex-row justify-end items-center">
    <div
      class="icon-panel-submit w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleSubmit()"
    >
      <app-icon icon="check" cssClass="icon-panel-icon"></app-icon>
    </div>
    <div
      class="icon-panel-cancel w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleCancel()"
    >
      <app-icon icon="close" cssClass="icon-panel-icon"></app-icon>
    </div>
  </div>
</div>
